<template>

  <div class="p-grid">

    <Toast />

    <div class="p-col-12">
      <Breadcrumb :home="breadcrumbHome" :model="breadcrumbItems" />
    </div>

    <div class="p-col-12">
      <div class="card" v-if="loadingIndicator">
        <p>Loading, please wait . . .</p>
        <ProgressBar mode="indeterminate" style="height: .5em" />
      </div>

      <div class="card">
        <div class="p-d-flex p-jc-between">
          <div><h3>Report Management</h3></div>
        </div>

        <Message v-for="(msg, index) in messages" :severity="msg.severity" :key="index" :life="5000" :sticky="false">{{msg.content}}</Message>

        <div class="p-grid p-fluid">
			<div class="p-col-8">

                     <div style="padding-bottom: 10px;padding-top: 10px;"   >

                     <h5>Report Type</h5>
                     <Dropdown v-model="input.reportType.value"  :options="dropdownItems_reportType" optionLabel="name" optionValue="code" placeholder="Select Report Type" :filter="true" filterPlaceholder="Find Report Type" :showClear="true" :required="true" :class="input.reportType.errMsg ? 'p-invalid' : null" @change="selectedReport()"/>
                     <small class="p-invalid" v-if="input.reportType.errMsg" >{{ input.reportType.errMsg }}</small>

                     </div>

                     <div style="padding-bottom: 10px;padding-top: 10px;"  v-if="this.input.reportType.value == 'DEPOSIT' || this.input.reportType.value == 'DEPOSIT1' || this.input.reportType.value == 'WITHDRAW' || this.input.reportType.value == 'WITHDRAW1' || this.input.reportType.value == 'INVLIST1' || this.input.reportType.value == 'INVLIST2' || this.input.reportType.value == 'INVLIST3' || this.input.reportType.value == 'INVLIST4' || this.input.reportType.value == 'INVLIST5' || this.input.reportType.value == 'INVLIST6' || this.input.reportType.value == 'INVLIST7' || this.input.reportType.value == 'INVLIST8' || this.input.reportType.value == 'INVLIST9' || this.input.reportType.value == 'INVLIST10' || this.input.reportType.value == 'SLOT' || this.input.reportType.value == 'TRANM'"  >

                    <h5>Customer</h5>

                     <MultiSelect v-model="input.customer_id.value" :options="dropdownItems_clientname" optionLabel="name"  optionValue="code" placeholder="Select Customer"  :required="true" :filter="true" :class="input.customer_id.errMsg ? 'p-invalid' : null"/>
                     <small class="p-invalid" v-if="input.customer_id.errMsg">{{ input.customer_id.errMsg }}</small>

                     </div>

                    <div style="padding-bottom: 10px;padding-top: 10px;" v-if="this.input.reportType.value == 'DEPOSIT' || this.input.reportType.value == 'DEPOSIT1' || this.input.reportType.value == 'WITHDRAW' || this.input.reportType.value == 'WITHDRAW1' || this.input.reportType.value == 'CROSS2' || this.input.reportType.value == 'CROSS3' || this.input.reportType.value == 'CROSS1'"  >
                    <h5 >Transaction Date</h5>
                     <Calendar  v-model="input.date.value" dateFormat="yy-mm-dd" @date-select="dateFormat($event)" :showButtonBar="true" :show-icon="true" placeholder="Select Transaction Date" :required="true" :class="input.date.errMsg ? 'p-invalid' : null" />
                    <small class="p-invalid" v-if="input.date.errMsg">{{ input.date.errMsg }}</small>
                    </div>

                    <div style="padding-bottom: 10px;padding-top: 10px;" v-if="this.input.reportType.value == 'TRANM' || this.input.reportType.value == 'CROSS2M' || this.input.reportType.value == 'CROSS3M'" >

                     <h5 >Transaction Month</h5>
                     <Calendar  v-model="input.month.value" view="month" @date-select="dateFormat2($event)" :showButtonBar="true" :show-icon="true" placeholder="Select Transaction month" :required="true" :class="input.month.errMsg ? 'p-invalid' : null"  />
                    <small class="p-invalid" v-if="input.month.errMsg">{{ input.month.errMsg }}</small>


                    </div>
			</div>

			<div class="p-col-6">

			</div>
		</div>

        <div  class="card" align="right">
            <Button label="Generate" class="p-button-success" @click="submitReport()" />
        </div>

      </div>
    </div>


  </div>


</template>

<script>
import { genReport } from '@/api/report'
import moment from "moment"

export default {
  name: "ReportingModule",

  data() {
    return {
      breadcrumbHome: { icon: 'pi pi-home', to: { name: 'dashboard' } },
      breadcrumbItems: [
        { label:'Reporting Module', to: this.$route.path }
      ],
      messages: [],
      loadingIndicator: false,

      reports: [],
      tableLoading: true,
      input: {
        'reportType': {value: null , errMsg: null},
        'customer_id': {value: null , errMsg: null},
        'date': {value: null , errMsg: null},
        'month': {value: null , errMsg: null},
      },
      dropdownItems_clientname: [],
      dropdownItems_reportType: [],
      reportData: {
        rolePermissions: [],
        extraPermissions: []
      },
      expandedRows: null
    }
  },

  created() {
    let flashMessage = this.$session.flash.get("flash-message")
    if(flashMessage) {
      this.messages.push({ severity: this.$session.flash.get("flash-class"), content: flashMessage })
    }

    //this.getReportList()
    let addrList = this.$store.getters.options.addresses
    this.$store.getters.options.companies.forEach(element => {
        addrList.find(addr => {
        if(element.code == addr.customer_id)
        this.dropdownItems_clientname.push({ code: element.code, name: element.display })
      })
    })


    this.$store.getters.options.report.forEach(element => {
      this.dropdownItems_reportType.push({ code: element.code, name: element.display })
    })
  },

  methods: {
    // getReportList() {
    //   this.tableLoading = true

    //   try {
    //     getReports()
    //       .then((res) => {

    //         if (res.data.total == 0) {

    //           this.isLoadNull = true
    //         }

    //         // this.rows = res.data.total
    //         // this.perPage = res.data.per_page
    //         // this.row_from = res.data.from

    //         this.reports = res.data.data
    //       })
    //       .catch(() => {
    //         this.messages.push({ severity: 'error', content: "Failed to get report list" })
    //       })
    //       .finally(() => this.tableLoading = false)
    //   } catch (e) {
    //     console.error(e)
    //     this.messages.push({ severity: 'error', content: "Failed to get report list" })
    //   }
    // },

    submitReport() {

      // Form Validation
      let doSubmit = true
      doSubmit = this.inputValidation(doSubmit)

      // Submit
      if (doSubmit) {
        this.loadingIndicator = true

        const typeOfRepWithoutClient =  [
            'CROSS2', 'CROSS3','CROSS2M','CROSS3M','CROSS1'
        ];



        let clientArr = [];
if (!typeOfRepWithoutClient.includes(this.input.reportType.value)) {
  if (this.input.customer_id.value.length !== 0) {
    this.input.customer_id.value.forEach(element => {
      clientArr.push(element);
    });
  } else {

    this.input.customer_id.errMsg = "Customer must be selected";
  }
} else {

  this.input.customer_id.value = [1]; // or any appropriate action to clear the value
}


        let newRepObj = {
          report_code: this.input.reportType.value,
          date: this.input.date.value,
          month: this.input.month.value,
          customer_id: clientArr,
          generated_by: this.$store.getters.authName,
          // driver_id: this.input.driver_id.value,
          // vehicle_id: this.input.vehicle_id.value,
        }

        // if(!this.$store.getters.authClientId) {
        //   newBoxObj.owner = this.input.owner.value.code
        //   newBoxObj.status = this.input.status.value.code
        // }

        try {
          genReport(newRepObj)
            .then((res) => {

              if (res.data.status) {

                // this.messages.push({ severity: 'success', content: res.data.message })
                this.$toast.add({severity:'success', summary: 'Success', detail: res.data.message, life: 5000})
                //window.location.href = res.data.reportPath;

                //this.forceFileDownload(res.data.reportPath, res.data.reportName)

                    // var fileURL = window.URL.createObjectURL(new Blob([res.data.reportPath]));
                    // var fileLink = document.createElement('a');

                    // fileLink.href = fileURL;
                    // fileLink.setAttribute('download', res.data.reportName);
                    // document.body.appendChild(fileLink);

                    // fileLink.click();
                    //window.open(res.data.reportPath, 'Download');

                    window.location.href = res.data.reportPath;

                //this.getReportList()

              } else {
                this.$toast.add({severity:'error', summary: 'Error', detail: res.data.message, life: 5000})
              }
            })

            .catch((e) => {
              console.log(e)
              if(e.response.status && e.response.status == 422) {

                this.$toast.add({severity:'error', summary: 'Error', detail: e.response.data.message, life: 5000})

                if(e.response.data.errors) {

                  let errObj = e.response.data.errors
                  this.input.reportType.errMsg = errObj.reportType ? errObj.reportType[0] : null
                  this.input.customer_id.errMsg = errObj.customer_id ? errObj.customer_id[0] : null
                  this.input.date.errMsg = errObj.date ? errObj.date[0] : null
                  this.input.month.errMsg = errObj.month ? errObj.month[0] : null

                }
              } else {
                this.$toast.add({severity:'error', summary: 'Error', detail: "Failed to generate due to network error.", life: 5000})
              }
            })
            .finally(() => this.loadingIndicator = false )
        } catch (e) {

          this.loadingIndicator = false
          this.$toast.add({severity:'error', summary: 'Error', detail: "Failed to generate due to network error.", life: 5000})
        }
      } else {
        this.loadingIndicator = false
      }

      window.scrollTo(0,0)
    },

    calcRptSize(bytes) {
      if(bytes >= 1000000000) {
        return (bytes/1000000000).toFixed(2) + ' GB'
      } else if(bytes >= 1000000) {
        return (bytes/1000000).toFixed(2) + ' MB'
      } else if(bytes >= 1000) {
        return parseInt(bytes/1000) + ' KB'
      } else {
        return bytes + ' Bytes'
      }
    },

    inputValidation(doSubmit) {
      this.input.reportType.errMsg = null
      this.input.customer_id.errMsg = null
      this.input.date.errMsg = null
      this.input.month.errMsg = null

      const typeOfRep =  [
            'DEPOSIT', 'DEPOSIT1', 'WITHDRAW', 'WITHDRAW1', 'CROSS2', 'CROSS3'
        ];

      // const typeOfRepWithClientNoDate =  [

      // ];

      const typeOfRepWithoutClient =  [
            'CROSS2', 'CROSS3','CROSS2M','CROSS3M','CROSS1'
        ];

        const typeOfRepWithoutDateMonth=  [
            'LIST1','CROSS1','INVLIST1', 'INVLIST2','INVLIST3', 'INVLIST4', 'INVLIST5', 'INVLIST6', 'INVLIST7', 'INVLIST8','INVLIST9', 'INVLIST10', 'SLOT'
        ];

      var repIndDateMonth = typeOfRep.includes(this.input.reportType.value);
      //var repIndWithoutClient = typeOfRepWithoutClient.includes(this.input.reportType.value);
      var repIndWithoutDateMonth = typeOfRepWithoutDateMonth.includes(this.input.reportType.value);
      // var repIndWitClientNoDate = typeOfRepWithClientNoDate.includes(this.input.reportType.value);

      if (!this.input.reportType.value) {
        doSubmit = false
        this.input.reportType.errMsg = "Report Type is required."
      }

      // if(!repIndWithoutClient){
      //   if (!this.input.customer_id.value) {
      //     doSubmit = false
      //     this.input.customer_id.errMsg = "Customer is required."
      //   }
      // }else{
      //   this.input.customer_id.value = '1';
      // }
//         console.log(this.input.reportType.value ,typeOfRepWithoutClient )
//       if (!repIndWithoutClient.includes(this.input.reportType.value)) {
//   if (!this.input.customer_id.value) {
//     console.log("sada")
//     doSubmit = false;
//     this.input.customer_id.errMsg = "Customer is required.";
//   }
// } else {
//   this.input.customer_id.value = '1';
// }

if (typeOfRepWithoutClient.includes(this.input.reportType.value)) {
  this.input.customer_id.value = '1';
} else {
  if (!this.input.customer_id.value) {
    doSubmit = false;
    this.input.customer_id.errMsg = "Customer is required.";
  }
}

      if(!repIndWithoutDateMonth){
        if (!this.input.date.value){
          if(repIndDateMonth){
              doSubmit = false
              this.input.date.errMsg = "Date is required."
          }
        }

        if(!this.input.month.value){
            if(!repIndDateMonth){
              doSubmit = false
              this.input.month.errMsg = "Month is required."
            }
        }
      }

      return doSubmit
    },

    permited(permissions) {
      return this.$parent.permited(permissions)
    },

    dateFormat(event) {
      this.input.date.value = moment(event).format('YYYY-MM-DD');
    },

    dateFormat2(event) {
      this.input.month.value = moment(event).format('YYYY-MM');
    },

    forceFileDownload(response, title) {

      const url = window.URL.createObjectURL(new Blob([response.data]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', title)
      document.body.appendChild(link)
      link.click()
    },

    selectedReport() {
    var repSelected = this.input.reportType.value

      const typeOfRep =  [
            'DEPOSIT', 'DEPOSIT1', 'WITHDRAW', 'WITHDRAW1', 'CROSS2', 'CROSS3',
            'LIST1', 'CROSS1', 'INVLIST1', 'INVLIST2',
            'INVLIST3', 'INVLIST4', 'INVLIST5', 'INVLIST6', 'INVLIST7', 'INVLIST8',
            'INVLIST9', 'INVLIST10', 'SLOT'
        ];

      var repInd = typeOfRep.includes(repSelected);

      if(repInd){
        this.input.month.value = null;
      }else{
        this.input.date.value = null;
      }

    },
  }


}
</script>

<style>
	#overlay{
		position: fixed;
		top: 0;
		left: 0;
		bottom: 0;
		z-index: 100;
		width: 100%;
		height:100%;
		display: none;
		background: rgba(0,0,0,0.6);
	}
	.cv-spinner {
		height: 100%;
		display: flex;
		justify-content: center;
		align-items: center;
	}
	.spinner {
		width: 40px;
		height: 40px;
		border: 4px #ddd solid;
		border-top: 4px #1C4E9E solid;
		border-radius: 100%;
		animation: sp-anime 0.8s infinite linear;
		z-index: 999;
	}
	@keyframes sp-anime {
		100% {
			transform: rotate(360deg);
		}
	}
	.is-hide{
		display:none;
	}

</style>
